export default __webpack_public_path__ + "static/list-block-1-bg-desktop-6551885b4569aa65adbbfff0ca8ef3dd.png";